function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { fromUrl, parseDomain as parseDomainUtil, ParseResultType } from "parse-domain";
import { PERSONAL_EMAIL_DOMAINS } from "./constants.js";
/**
 * Parse a domain from a URL or domain string
 */ var DomainUtil = /*#__PURE__*/ function() {
    "use strict";
    function DomainUtil() {
        _class_call_check(this, DomainUtil);
    }
    _create_class(DomainUtil, null, [
        {
            key: "parseEmailDomain",
            value: function parseEmailDomain(email) {
                if (!email) {
                    return null;
                }
                var _email_split = _sliced_to_array(email.split("@"), 2), domain = _email_split[1];
                if (domain) {
                    return DomainUtil.parseDomain(domain);
                }
                return null;
            }
        },
        {
            key: "parseDomain",
            value: function parseDomain(urlOrDomain) {
                // First try to use url parser
                urlOrDomain = urlOrDomain.toLowerCase();
                var parseDomainRes = parseDomainUtil(fromUrl(urlOrDomain));
                if (parseDomainRes.type === ParseResultType.Listed) {
                    return [
                        parseDomainRes.domain
                    ].concat(_to_consumable_array(parseDomainRes.topLevelDomains)).join(".");
                }
                // Try prepending http://
                var httpUrl = "http://".concat(urlOrDomain);
                var parseDomainResHttp = parseDomainUtil(fromUrl(httpUrl));
                if (parseDomainResHttp.type === ParseResultType.Listed) {
                    return [
                        parseDomainResHttp.domain
                    ].concat(_to_consumable_array(parseDomainResHttp.topLevelDomains)).join(".");
                }
                try {
                    var parsedUrl = new URL(urlOrDomain);
                    var hostName = parsedUrl.hostname;
                    // Only include the primary domain / root domain
                    var parts = hostName.split(".");
                    if (parts.length === 2) {
                        return hostName || null;
                    } else if (parts.length === 3) {
                        return parts.slice(1).join(".") || null;
                    } else {
                        return parts.slice(1, 3).join(".") || null;
                    }
                } catch (e) {
                    // Remove anything after # or ?
                    urlOrDomain = urlOrDomain.split("#")[0];
                    urlOrDomain = urlOrDomain.split("?")[0];
                    // Handle example.com and www.example.com and domain.example.com
                    var parts1 = urlOrDomain.split(".");
                    if (parts1.length === 2) {
                        return urlOrDomain || null;
                    } else if (parts1.length === 3) {
                        return parts1.slice(1).join(".") || null;
                    } else {
                        return parts1.slice(1, 3).join(".") || null;
                    }
                }
            }
        },
        {
            key: "personalEmailDomains",
            get: function get() {
                return new Set(PERSONAL_EMAIL_DOMAINS);
            }
        }
    ]);
    return DomainUtil;
}();
export default DomainUtil;
